<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Crear Usuario",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
                {
                text: "Crear Usuario",
                active: true
                }
            ],
            datos:{
                tipo:'',
                rut:'',
                name:'',
                email:'',
                telefono:'',
                cargo:'',
                rol:'',
                carrera:'',
                ano:'',
                retencion:'',
                banco:'',
                tipo_cuenta:'',
                n_cuenta:''
            },
            bool_usuarios:false,
            bool_laborantes:false,
            usuario:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            bancos:[],
            tipo:['Cuenta Vista', 'Cuenta Rut', 'Cuenta Corriente', 'Cuenta Ahorro'],
            retencion:['15,25', '25'],
            todosCargos:['Coordinador Vigente','Supervisor','Director','Decana','Gastos']
        };
    },
    computed:{
        canManageUsuarios() {
            const rol = this.user && this.user.rol ? String(this.user.rol) : '';
            return rol === 'Admin' || rol === 'SuperAdmin';
        },
        cargos() {
            return this.todosCargos;
        },
        isEmailValid() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.datos.email);
        }
    },
    methods: {
        msg(tipo,titulo, text){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: text,
                showConfirmButton: false,
                timer: 5000
            });
        },
        validacion_usuario(){
            if(this.datos.cargo=='' || this.datos.cargo==null){
                this.msg('error','Falta campo por completar','Tipo de Usuario');
                return
            }
            if(this.datos.rut=='' || this.datos.rut==null){
                this.msg('error','Falta campo por completar','Rut');
                return
            }
            if(this.datos.name=='' || this.datos.name==null){
                this.msg('error','Falta campo por completar','Nombre');
                return
            }
            if(this.datos.email=='' || this.datos.email==null){
                this.msg('error','Falta campo por completar','Correo');
                return
            }
            if(this.datos.telefono=='' || this.datos.telefono==null){
                this.msg('error','Falta campo por completar','Teléfono');
                return
            }
            this.crear_usuario();
        },
        validacion_laborates(){
            if(this.datos.rut=='' || this.datos.rut==null){
                this.msg('error','Falta campo por completar','Rut');
                return
            }
            if(this.datos.name=='' || this.datos.name==null){
                this.msg('error','Falta campo por completar','Nombre');
                return
            }
            if(this.datos.email=='' || this.datos.email==null){
                this.msg('error','Falta campo por completar','Correo');
                return
            }
            if(this.datos.telefono=='' || this.datos.telefono==null){
                this.msg('error','Falta campo por completar','Teléfono');
                return
            }
            this.datos.rol='Laborante';
            this.crear_usuario();
        },
        crear_usuario(){
            if (this.datos.cargo=='Coordinador Vigente') {
                this.datos.rol='Coordinador';
            }else if(this.datos.cargo=='Coordinador de Reemplazo'){
                this.datos.rol='Coordinador';
            }else if(this.datos.cargo=='Supervisor'){
                this.datos.rol='Admin';
            }else if(this.datos.cargo=='Director'){
                this.datos.rol='Director';
            }else if(this.datos.cargo=='Decana'){
                this.datos.rol='Decana';
            }else if(this.datos.cargo=='Gastos'){
                this.datos.rol='Gastos';
            }else if(this.datos.cargo==''){
                this.datos.rol='Laborante';
            }
            let formData = new FormData();
            formData.append('tipo', this.datos.tipo);
            formData.append('rut', this.datos.rut);
            formData.append('name', this.datos.name);
            formData.append('email', this.datos.email);
            formData.append('telefono', this.datos.telefono);
            formData.append('cargo', this.datos.cargo);
            formData.append('rol', this.datos.rol);
            formData.append('carrera', this.datos.carrera);
            formData.append('ano', this.datos.ano);
            formData.append('retencion', this.datos.retencion);
            if (this.datos.banco && this.datos.banco.id) {
                formData.append('banco', this.datos.banco.id);
            } else {
                formData.append('banco', '');
            }
            formData.append('tipo_cuenta', this.datos.tipo_cuenta);
            formData.append('n_cuenta', this.datos.n_cuenta);
            axios.post('/api/crear_usuario',formData).then(res=>{
                this.msg(res.data.color, res.data.mensaje);
                if(res.data.estado){
                    this.datos.tipo='';
                    this.datos.rut='';
                    this.datos.name='';
                    this.datos.email='';
                    this.datos.telefono='';
                    this.datos.cargo='';
                    this.datos.rol='';
                    this.datos.carrera='';
                    this.datos.ano='';
                    this.datos.retencion='';
                    this.datos.banco='';
                    this.datos.tipo_cuenta='';
                    this.datos.n_cuenta='';
                }
            }).catch(error => {
                const msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message : error.message;
                this.msg('error', 'Error al crear usuario: ' + msg);
            })
        },
        usuarios(){
            if (!this.canManageUsuarios) {
                this.bool_usuarios = false;
                this.bool_laborantes = true;
                return;
            }
            this.datos.tipo='';
            this.datos.rut='';
            this.datos.name='';
            this.datos.email='';
            this.datos.telefono='';
            this.datos.cargo='';
            this.datos.rol='';
            this.datos.carrera='';
            this.datos.ano='';
            this.datos.retencion='';
            this.datos.banco='';
            this.datos.tipo_cuenta='';
            this.datos.n_cuenta='';
            this.bool_usuarios=true;
            this.bool_laborantes=false;
        },
        laborantes(){
            this.datos.tipo='';
            this.datos.rut='';
            this.datos.name='';
            this.datos.email='';
            this.datos.telefono='';
            this.datos.cargo='';
            this.datos.rol='';
            this.datos.carrera='';
            this.datos.ano='';
            this.datos.retencion='';
            this.datos.banco='';
            this.datos.tipo_cuenta='';
            this.datos.n_cuenta='';
            this.bool_usuarios=false;
            this.bool_laborantes=true;
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos.rut = cleanRut;
            }

            this.cuenta_rut();
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        getRutBodyWithoutDv(value) {
            const cleanRut = this.cleanRut(value || '');
            return cleanRut.length > 1 ? cleanRut.slice(0, -1) : '';
        },
        validateRut() {
            let rut = this.cleanRut(this.datos.rut);
            let digito_verificador = this.datos.rut.substr(-1);
            rut = rut.substr(0, rut.length - 1);
            let serie = 0;
            let producto = 0;
            do {
                producto += (rut % 10) * ((serie % 6) + 2);
                serie++;
            } while (rut = Math.floor(rut / 10));
            let resto = producto % 11;
            let resultado = 11 - resto;
            if (resultado == 11) {
                resultado = 0;
            } else if (resultado == 10) {
                resultado = 'K';
            }
            if (digito_verificador != resultado || digito_verificador=='') {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        validateEmail() {
            if (this.datos.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir letras (incluyendo tildes y ñ), espacios y teclas de control
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault();
            }
        },
        labelselect_tipo ({ nombre }) {
            return `${nombre}`
        },
        cuenta_rut(rut){
            if(this.datos.tipo_cuenta=='Cuenta Rut'){
                this.datos.n_cuenta = this.getRutBodyWithoutDv(this.datos.rut);
            }else{
                this.datos.n_cuenta = ''
            }
        }
    },
    created(){
        if (localStorage.getItem("usuario")) {
            const usuario = localStorage.getItem("usuario");
            this.usuario = usuario;
            if (this.usuario=='usuario' && this.canManageUsuarios) {
                this.bool_usuarios=true;
                this.bool_laborantes=false;
            }
            if(this.usuario=='laborante'){
                this.bool_usuarios=false;
                this.bool_laborantes=true;
            }
            localStorage.removeItem("usuario");
        } else if (!this.canManageUsuarios) {
            this.bool_usuarios = false;
            this.bool_laborantes = true;
        }
        axios.get('/api/get_bancos').then(response => {
            this.bancos = response.data.bancos;
        });

    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">

                <!-- Encabezado con selector de formulario -->
                <div class="card">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-user-plus font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Crear Usuario</h5>
                            <small class="text-white" style="opacity:.8;">Selecciona el tipo de usuario a registrar</small>
                        </div>
                    </div>
                    <div class="card-body py-3">
                        <div class="d-flex" style="gap:10px;">
                            <button @click="laborantes" type="button"
                                :class="bool_laborantes ? 'btn-ugm-active' : 'btn-ugm-inactive'">
                                <i class="bx bx-id-card mr-1"></i> Laborantes
                            </button>
                            <button v-if="canManageUsuarios" @click="usuarios" type="button"
                                :class="bool_usuarios ? 'btn-ugm-active' : 'btn-ugm-inactive'">
                                <i class="bx bx-group mr-1"></i> Usuarios
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Formulario Usuarios -->
                <div class="card mt-3" v-if="canManageUsuarios && bool_usuarios">
                    <div class="card-body">
                        <div class="p-3 mb-4 rounded"
                            style="border-left:4px solid #252C5F; background:#f8f9fa;">
                            <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">
                                <i class="bx bx-group mr-1"></i> Datos del Usuario
                            </h6>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Tipo de Usuario :" label-for="input-cargo">
                                    <multiselect
                                        v-model="datos.cargo"
                                        :options="cargos"
                                        placeholder="Seleccionar opción"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover">
                                        <template v-slot:noOptions><p>No hay opciones</p></template>
                                        <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="RUT :">
                                    <b-form-input class="border-primary" v-model="datos.rut"
                                        @blur="validateRut" @input="formatRut" maxlength="12"></b-form-input>
                                    <p v-if="ruterror" class="small text-danger mt-1">{{ ruterror }}</p>
                                </b-form-group>
                                <b-form-group label="Nombre :">
                                    <b-form-input class="border-primary" v-model="datos.name"
                                        @keydown="restrictInput_withspace"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Correo :">
                                    <b-form-input class="border-primary" v-model="datos.email"
                                        @blur="validateEmail"></b-form-input>
                                    <p v-if="emailError" class="small text-danger mt-1">{{ emailError }}</p>
                                </b-form-group>
                                <b-form-group label="Teléfono :">
                                    <b-form-input type="phone" class="border-primary" v-model="datos.telefono"
                                        @input="formatPhoneNumber" @blur="validatePhoneNumber"
                                        @keydown="restrictToNumbers" maxlength="12"></b-form-input>
                                    <p v-if="phoneerror" class="small text-danger mt-1">{{ phoneerror }}</p>
                                </b-form-group>
                            </div>
                            <div class="col-12">
                                <p class="small mb-3" style="color:#61B7E4;">
                                    <i class="bx bx-info-circle mr-1"></i> Todos los campos son obligatorios
                                </p>
                            </div>
                            <div class="offset-md-3 col-md-6">
                                <b-button block @click="validacion_usuario"
                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                    <i class="bx bx-user-check mr-1"></i> Registrar Usuario
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Formulario Laborantes -->
                <div class="card mt-3" v-if="bool_laborantes">
                    <div class="card-body">

                        <!-- Sección datos personales -->
                        <div class="p-3 mb-4 rounded"
                            style="border-left:4px solid #252C5F; background:#f8f9fa;">
                            <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">
                                <i class="bx bx-user mr-1"></i> Datos Personales
                            </h6>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="RUT :">
                                    <b-form-input class="border-primary" v-model="datos.rut"
                                        @blur="validateRut" @input="formatRut()" maxlength="12"></b-form-input>
                                    <p v-if="ruterror" class="small text-danger mt-1">{{ ruterror }}</p>
                                </b-form-group>
                                <b-form-group label="Nombre :">
                                    <b-form-input class="border-primary" v-model="datos.name"
                                        @keydown="restrictInput_withspace"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Correo :">
                                    <b-form-input class="border-primary" v-model="datos.email"
                                        @blur="validateEmail"></b-form-input>
                                    <p v-if="emailError" class="small text-danger mt-1">{{ emailError }}</p>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Teléfono :">
                                    <b-form-input class="border-primary" v-model="datos.telefono"
                                        @input="formatPhoneNumber" @blur="validatePhoneNumber"
                                        @keydown="restrictToNumbers" maxlength="12"></b-form-input>
                                    <p v-if="phoneerror" class="small text-danger mt-1">{{ phoneerror }}</p>
                                </b-form-group>
                                <b-form-group label="Carrera :">
                                    <b-form-input class="border-primary" v-model="datos.carrera"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Año :">
                                    <b-form-input class="border-primary" v-model="datos.ano"></b-form-input>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- Sección datos bancarios -->
                        <div class="p-3 mb-4 mt-2 rounded"
                            style="border-left:4px solid #CB9700; background:#f8f9fa;">
                            <h6 class="mb-0 font-weight-bold" style="color:#CB9700;">
                                <i class="bx bx-wallet mr-1"></i> Datos Bancarios
                            </h6>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="% Retención :">
                                    <multiselect
                                        v-model="datos.retencion"
                                        :options="retencion"
                                        placeholder="Seleccionar opción"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover">
                                        <template v-slot:noOptions><p>No hay opciones</p></template>
                                        <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="Banco :">
                                    <multiselect
                                        v-model="datos.banco"
                                        :options="bancos"
                                        :custom-label="labelselect_tipo"
                                        placeholder="Seleccionar opción"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover">
                                        <template v-slot:noOptions><p>No hay opciones</p></template>
                                        <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Tipo de Cuenta :">
                                    <multiselect
                                        v-model="datos.tipo_cuenta"
                                        :options="tipo"
                                        placeholder="Seleccionar opción"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                        @select="cuenta_rut">
                                        <template v-slot:noOptions><p>No hay opciones</p></template>
                                        <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="Nº Cuenta :">
                                    <b-form-input class="border-primary" v-model="datos.n_cuenta"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-12">
                                <p class="small mb-3" style="color:#61B7E4;">
                                    <i class="bx bx-info-circle mr-1"></i> Todos los campos son obligatorios
                                </p>
                            </div>
                            <div class="offset-md-3 col-md-6">
                                <b-button block @click="validacion_laborates"
                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                    <i class="bx bx-user-check mr-1"></i> Registrar Laborante
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-active {
    background: #252C5F;
    border: 2px solid #252C5F;
    color: #fff !important;
    font-weight: 600;
    padding: 6px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all .2s;
}
.btn-ugm-inactive {
    background: #fff;
    border: 2px solid #252C5F;
    color: #252C5F !important;
    font-weight: 400;
    padding: 6px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all .2s;
}
.btn-ugm-inactive:hover {
    background: #f0f3ff;
}
</style>
